module.exports.isBrowser = true
module.exports.isReactNative = false